import { render, staticRenderFns } from "./IconsSelect.vue?vue&type=template&id=dcc56bcc&"
import script from "./IconsSelect.vue?vue&type=script&lang=js&"
export * from "./IconsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports